import React, { useState, useEffect } from "react";
import axios from "axios";
import { Breadcrumb, Title } from "../components";
import { functionary } from "../assets/data/data";
import FunctionaryCard from "../components/functionary/FunctionaryCard";
import UseFetch from "../components/hooks/UseFetch";
import { useNavigate } from "react-router-dom";

const Functionary = () => {
  const navigate = useNavigate();
  const [status, setStatus] = useState("leader");
  const { data } = UseFetch("workers", {
    method: "get",
    details: {},
  });
  const user = data?.filter((person) => person.type === status);

  console.log(user);
  const functionaryDetail = (item) => {
    // console.log(item);
    navigate("/functionary/" + item._id, {
      state: item,
    });
  };
  return (
    <div className="container">
      <Breadcrumb current="Hodimlar" />
      <Title title="Hodimlar" subtitle="find the right course for you" />
      <section className="courses my-0 ">
        <div className="row justify-content-center">
          <div className="col-12">
            <nav>
              <div
                className="nav nav-tabs mb-4 border-0 justify-content-center "
                id="nav-tab"
                role="tablist"
              >
                <button
                  className="nav-link active rounded-3 me-2 px-4 mb-2 mb-md-0"
                  onClick={() => setStatus("leader")}
                  data-bs-toggle="tab"
                >
                  Rahbariyat
                </button>
                <button
                  className="nav-link rounded-3 me-2 px-4 mb-2 mb-md-0"
                  onClick={() => setStatus("worker")}
                  data-bs-toggle="tab"
                >
                  Ilmiy hodimlar
                </button>
                <button
                  className="nav-link rounded-3 me-2 px-4 mb-2 mb-md-0"
                  onClick={() => setStatus("researcher")}
                  data-bs-toggle="tab"
                >
                  Ilmiy tadqiqotchilar
                </button>
              </div>
            </nav>
            <div className="tab-content " id="nav-tabContent">
              <div
                className="tab-pane fade show active"
                id="ielts"
                role="tabpanel"
                aria-labelledby="ielts-tab"
              >
                <div className="row justify-content-center g-4 ">
                  {user?.map((item) => (
                    <FunctionaryCard
                      key={item._id}
                      data={item}
                      Fun={functionaryDetail}
                    />
                  ))}
                  {/* <Pagination
                    currentPage={next.page}
                    setPage={next.limit}
                    total={functionary.length}
                  /> */}
                </div>
              </div>
            </div>
          </div>
          <div className="col-12"></div>
        </div>
      </section>
    </div>
  );
};

export default Functionary;
